import { initSwipers } from "./slider";
import { choseSize } from "./chosesize";
import { setUserCountry } from "./usercountry";
import { renderDeliveryWindow } from "./deliverywindow";
document.addEventListener("DOMContentLoaded", function () {
  initSwipers();
  choseSize();
  setUserCountry();
  renderDeliveryWindow();
});